module.exports = __webpack_public_path__ + "img/18_2.c19c842c.png";